module.exports = __webpack_public_path__ + "img/INTERIOR-CIAZ-2.56a65e64.jpg";